module.exports = __webpack_public_path__ + "kaitak_image_support_02.364dffe28c06f8ee6c4a.png";